import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpRequestMethods,
  LoggingService,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { OauthAEMConfig } from '../../models';
import { OAuthFeatureConfig } from '../models/config.interfaces';
import { DashboardResponse } from '../models/dashboard.interfaces';
import { EndpointKeys, IDP_APPS } from '../models/login.constants';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  _errorHandler = handleError.bind(this);

  private _oAuthConfig: OAuthFeatureConfig = {
    app: 'COMMON',
    endpointKey: 'APP_AUTH_CONFIG_JSON'
  };

  constructor(
    private http: HttpClient,
    private logging: LoggingService,
    private appConfig: AppConfigService,
    @Optional()
    @Inject('OAUTH_FEATURE_CONFIG')
    private oAuthFeatureConfig: OAuthFeatureConfig
  ) {
    this.getAuthConfigEndpoint(oAuthFeatureConfig);
  }

  getAuthConfigEndpoint(config: OAuthFeatureConfig) {
    if (config) {
      this._oAuthConfig = config;
    }
  }

  getContent = (): Observable<DashboardResponse> =>
    new ApiBuilder<Record<string, string | number>, DashboardResponse>(
      this.http,
      this.appConfig
    )
      .app(IDP_APPS.COMMON)
      .endpointKey(EndpointKeys['DASHBOARD_BFF_URL'])
      .method(HttpRequestMethods['POST'])
      .payload({})
      .errorHandler(this._errorHandler)
      .library('SESSION SERVICE')
      .create();

  getAuthConfigResponse = (): Observable<OauthAEMConfig> => {
    return new ApiBuilder<undefined, OauthAEMConfig>(this.http, this.appConfig)
      .app(this._oAuthConfig.app)
      .endpointKey(this._oAuthConfig.endpointKey)
      .method(HttpRequestMethods['GET'])
      .errorHandler(this._errorHandler)
      .library('SESSION SERVICE')
      .create();
  };
}
